import React, { useEffect, useState } from 'react';
import firebase, { firebaseAnalytics }  from './Firebase';
import 'firebase/storage';
import 'firebase';
import { Link } from 'react-router-dom';
import { useHistory } from 'react-router';
import ReactTagInput from "@pathofdev/react-tag-input";
import "@pathofdev/react-tag-input/build/index.css";   
import { Spinner, Accordion, AccordionToggle, Card, AccordionCollapse, Button, ToggleButton, ToggleButtonGroup, Modal, ModalBody } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser,  faCalendar, faCheck, faTimes , faTrashAlt, faPaperPlane, faImages, faPen, faHeart, faPaperclip, faTimesCircle, faShareAlt, faLink } from '@fortawesome/free-solid-svg-icons';
import {
    EmailIcon,
    EmailShareButton,
    FacebookIcon,
    FacebookMessengerIcon,
    FacebookMessengerShareButton,
    FacebookShareButton,
    TelegramIcon,
    TelegramShareButton,
    TwitterIcon,
    TwitterShareButton,
    WhatsappIcon,
    WhatsappShareButton,
  } from "react-share";

export default function Community() {  

    const ref = firebase.firestore().collection('post');
    const storageRef = firebase.storage().ref();
    const [posts, setPosts] = useState([]);
    const [filteredPosts, setFilteredPosts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [commento, setCommento] = useState('');
    const [reply, setReply] = useState('');
    const [file, setFile] = useState();
    const [tags, setTags] = useState([])
    const [modify, setModify] = useState('');
    const [modifyRep, setModifyRep] = useState('');
    const [modificaTags, setModificaTags] = useState('');
    const [modifica, setModifica] = useState('');
    const [modificaRep, setModificaRep] = useState('');
    const [uploadingPost, setUploadingPost] = useState(false);
    const [uploadingReply, setUploadingReply] = useState(false);
    const [tipo, setTipo] = useState('post');
    const [currentImage, setCurrentImage] = useState({});
    const [viewerIsOpen, setViewerIsOpen] = useState(false);
    const [selectedTags, setSelectedTags] = useState([]);
    const tagList = ["cbd","thc","erba","hash","coltivazione","vaporizzare","edibili","legalizzazione","socialclub","coffeeshop","fattanza","annunci"] 
    const [showShare, setShowShare] = useState(false); 
    const [url, setUrl] = useState()
    const [temp, setTemp] = useState();
    let history = useHistory();
    var id = history.location.pathname.split("/")[2] === undefined ? null:  history.location.pathname.split("/")[2] 

    useEffect(() => {
        firebaseAnalytics.logEvent("home_tab_visited");
        firebaseAnalytics.setCurrentScreen("home_tab")
        setLoading(true);
        if(id !== null){ renderSinglePost() }
        ref.onSnapshot(querySnapshot => updateState(querySnapshot));
        setLoading(false);
    }, []);

    const updateState = querySnapshot => {
        const items = [];
        querySnapshot.forEach(doc => items.push(doc.data()));
        items.sort(function compareNumbers(a, b) {
            return (b.data - a.data );
          })
        setPosts(items)
        setFilteredPosts(items)
    }

    const timeSince = date => {

        var seconds = Math.floor((new Date() - date) / 1000);
      
        var interval = seconds / 31536000;
      
        if (interval >= 1) {
          return Math.floor(interval) + " anni";
        }
        interval = seconds / 2592000;
        if (interval >= 1) {
          return Math.floor(interval) + " mesi";
        }
        interval = seconds / 86400;
        if (interval >= 1) {
          return Math.floor(interval) + " giorni";
        }
        interval = seconds / 3600;
        if (interval >= 1) {
          return Math.floor(interval) + " ore";
        }
        interval = seconds / 60;
        if (interval >= 1) {
          return Math.floor(interval) + " minuti";
        }
        return Math.floor(seconds) + " secondi";
    }

    const renderText = txt => {    
    var URL_REGEX = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/;
        return txt
        .split(" ")
        .map(part =>
        URL_REGEX.test(part) ? <a href={part} target="_blank" rel="noopener noreferrer">{part} </a> : part + " "
        );
    }

    const switchTagFilter = tags => {
        const filteredItems= []
        if(tags.length > 0){
            posts.forEach( item => {
                    var bool = false
                    tags.forEach( tag => {
                        if(item.tags.includes(tag))
                            bool = true
                    })
                    if(bool)
                        filteredItems.push(item)
                }
            )
            setFilteredPosts(filteredItems)
        }
        else
            setFilteredPosts(posts)
    }

    const removeLikeReply = (post, reply) => {
        var lks = reply.likes
        for( var i = 0; i < lks.length; i++){
            if(lks[i] === firebase.auth().currentUser.email)
                lks.splice(i, 1);
        }
        post.replies.map( rep => {
            if (rep.id === reply.id){
                rep.likes = lks
            }
        })
        firebase.firestore().collection('post').doc(post.id).update({
            replies: post.replies
        }).then(() => console.log("Like alla risposta rimosso!")).catch(error => console.error("Errore: ", error));
    }

    const addLikeReply = (post, reply) => {
        var lks = reply.likes
        for( var i = 0; i < lks.length; i++){
            if(lks[i] === firebase.auth().currentUser.email)
                return console.log("Il tuo like è già presente!")
        }
        lks.push(firebase.auth().currentUser.email)
        post.replies.map( rep => {
            if (rep.id === reply.id){
                rep.likes = lks
            }
        })
        firebase.firestore().collection('post').doc(post.id).update({
            replies: post.replies
        }).then(() => console.log("Like alla risposta aggiunto!")).catch(error => console.error("Errore: ", error));
    }
    
    const removeLikePost = post => {
        var lks = post.likes
        for( var i = 0; i < lks.length; i++){
            if(lks[i] === firebase.auth().currentUser.email)
                lks.splice(i, 1);
        }
        firebase.firestore().collection('post').doc(post.id).update({
            likes: lks
        }).then(() => console.log("Like al post rimosso!")).catch(error => console.error("Errore: ", error));
    }

    const addLikePost = post => {
        var lks = post.likes
        lks.push(firebase.auth().currentUser.email)
        firebase.firestore().collection('post').doc(post.id).update({
            likes: lks
        }).then(() => console.log("Like al post aggiunto!")).catch(error => console.error("Errore: ", error));
    }

    const deleteReply = (reps, replyID, postID) => {
        for( var i = 0; i < reps.length; i++){
            if(reps[i].id === replyID){
                reps[i].img.forEach( imgRef => {
                    storageRef.child("post_images/"+postID+"/replies/"+replyID+"/"+imgRef.name).delete()
                })
                reps.splice(i, 1);
            }
        }
        firebase.firestore().collection('post').doc(postID).update({ replies: reps })
        console.log("Risposta cancellata!")
    }

    const deleteAllRepliesImgs = post => {
        post.replies.forEach( reply => {
            reply.img.forEach( img => {
                storageRef.child("post_images/"+post.id+"/replies/"+reply.id+"/"+img.name).delete()
                console.log("Risposta cancellata!")
            })
        })
        console.log("Risposte cancellate!")
    }

    const deletePost = post => {

        deleteAllRepliesImgs(post)

        post.img.forEach( imgRef => {
            storageRef.child("post_images/"+post.id+"/"+imgRef.name).delete()
        })
        
        firebase.firestore().collection('post').doc(post.id).delete()
        console.log("Post cancellato!")
    }

    const updateReply = (reps, id) => {
        reps.map( rep => {
            if (rep.id === id){
                rep.text = modificaRep
                rep.last_modified = firebase.firestore.Timestamp.fromDate(new Date())
            }
        })
        return reps
    }

    async function sendReply(postID, replies){
        setUploadingReply(true)
        var imgRefs = []
        const date = firebase.firestore.Timestamp.fromDate(new Date());
        if(file !== undefined && file.target.files[0] !== undefined){
            let files = Array.from(file.target.files)
            for (let i = 0; i < files.length; i++) {
                var imgName = files[i].name
                var imgURL = await uploadFileReply(files[i], postID, date.seconds.toString())
                imgRefs.push({
                    name: imgName,
                    url: imgURL,
                })
              }
        }
        const rep = {
            email: firebase.auth().currentUser.email,
            user: firebase.auth().currentUser.displayName,
            text: reply,
            data: date,
            last_modified: date,
            likes: [],
            img: imgRefs,
            id: date.seconds.toString(),
        }
        replies.push(rep)
        firebase.firestore().collection('post').doc(postID).update({
            replies: replies
        }).then(() => console.log("Risposta pubblicata!")).catch(error => console.error("Errore: ", error));
        setReply('');
        setUploadingReply(false)
    }

    async function sendPost(){
        setUploadingPost(true)
        var imgRefs = []
        const date = firebase.firestore.Timestamp.fromDate(new Date());
        if(file !== undefined && file.target.files[0] !== undefined){
            let files = Array.from(file.target.files)
            for (let i = 0; i < files.length; i++) {
                var imgName = files[i].name
                var imgURL = await uploadFilePost(files[i], date.seconds.toString())
                imgRefs.push({
                    name: imgName,
                    url: imgURL,
                })
              }
        }
        firebase.firestore().collection('post').doc(date.seconds.toString()).set({
            email: firebase.auth().currentUser.email,
            user: firebase.auth().currentUser.displayName,
            text: commento,
            replies: [],
            tipo: tipo,
            img: imgRefs,
            data: date,
            last_modified: date,
            likes: [],
            tags: selectedTags,
            id: date.seconds.toString()
        }).then(() => console.log("Post pubblicato!")).catch(error => console.error("Errore: ", error));
        setCommento('')
        setTags([])
        setUploadingPost(false)
    }

    async function uploadFileReply( f, postID, replyID){
        var response = await storageRef.child("post_images/"+postID+"/"+"replies/"+replyID+"/"+f.name).put(f)
        file.target.value = null;
        return response.ref.getDownloadURL()
    }

    async function uploadFilePost( f, id ) {
        var response = await storageRef.child("post_images/"+id+"/"+f.name).put(f)
        file.target.value = null;
        return response.ref.getDownloadURL()
    }

    const renderReply = (post, reply, replies) => {
        return (
            <div className="post" style={{width: "100%"}}>
                {/* Parte alta risposta */}
                <div className="row input--commenti" style={{paddingTop:"1%", marginInline: "5%", justifyContent: "space-between"}}>
                    <div className='row' style={{width: "30%", textAlign: "left", alignSelf: "center"}}>
                        <div style={{marginRight: "3%", alignSelf: "center" }}>
                        </div>
                    </div>
                    {/* UTENTE */}
                    <div className='row' style={{width: "40%", alignContent: "center", justifyContent:"center" ,color: "lightgreen"}}>
                        <div style={{marginRight: "3%", alignSelf: "center" }}>
                            <FontAwesomeIcon  icon={faUser} />
                        </div>
                        <div style={{alignSelf: "center", textAlign: "center" }}>
                            <text> {reply.user} </text>
                        </div>
                    </div>
                    {/* DATA */}
                    <div className='row' style={{width: "30%", alignContent: "center", justifyContent: "center", color: "rgb(216, 216, 218)"}}>
                        <div style={{marginRight: "3%", alignSelf: "center" }}>
                            <FontAwesomeIcon icon={faCalendar}/> 
                        </div>
                        <div style={{alignSelf: "center", textAlign: "center" }}>
                            <text >{timeSince(reply.data.seconds*1000)} fa</text>
                        </div>
                    </div>
                </div>
                <hr style={{backgroundColor: "rgb(194, 194, 194)", marginInline: "4%", marginTop: "0%", height: "2px"}}/>
                <div className="row commenti--contenuti" >
                    {modifyRep !== reply.id ? 
                        <>
                            {/* Contenuto risposta */}
                            <div style={{width: "90%"}}>
                                <text style={{fontSize: 18}}>
                                    {renderText(reply.text)}
                                </text>
                                <br/>
                                <div className='post-gallery-div'>
                                    {reply.img.length > 0  ? (
                                        reply.img.map( (img, index) => {
                                            return (
                                                <div className='post-image-div' key={index}>
                                                    <img src={img.url} style={{width: "100%", borderRadius: "5%"}} onClick={() => {setCurrentImage(img); setViewerIsOpen(true)}}/>
                                                </div>)
                                            } 
                                        )
                                    )
                                        : null
                                    }
                                </div>
                                {/* MODAL IMAGE */}
                                <div className={viewerIsOpen? 'image-viewer open' : "image-viewer"} onClick={() => setViewerIsOpen(false)} >
                                    <img src={currentImage.url} />
                                </div> 
                                <br/>
                                <br/>
                            </div>
                        </> :
                        <>
                        {/* Input e pulsanti modifica risposta */}
                        <div style={{width: "90%"}}>
                            <textarea maxLength={1000} style={{fontSize: "18px"}} value={modificaRep} className='input' type='text' onChange={event => setModificaRep(event.target.value)} />
                            <div>
                                <Button 
                                    style={{marginLeft: "2%"}} size= "sm" variant ="info"
                                    onClick={() => {
                                        setModifyRep(null);
                                        firebase.firestore().collection('post').doc(post.id).update({ replies: updateReply(replies, reply.id) });
                                    }}>
                                    <FontAwesomeIcon color='white' icon={faCheck} />
                                </Button>
                                <Button 
                                    style={{marginLeft: "2%"}} variant="danger" size= "sm"
                                    onClick={() => setModifyRep(null)}
                                >
                                    <FontAwesomeIcon color='white' icon={faTimes} />
                                </Button>
                            </div>
                            
                        </div>
                        </>
                    }
                        
                        {/* Like */}
                        <div style={{width: "5%", textAlign: "center"}}>{reply.likes.length}
                            <br/>
                            {firebase.auth().currentUser !== null && reply.likes.length !== 0 && reply.likes.includes(firebase.auth().currentUser.email)? 
                                <FontAwesomeIcon className='cursor-pointer' icon={faHeart} color="red" onClick={() => removeLikeReply(post, reply)}/>:
                                <FontAwesomeIcon className='cursor-pointer' icon={faHeart} color="lightgrey" onClick={ () => {
                                    if (firebase.auth().currentUser !== null ) 
                                    addLikeReply(post, reply)
                                    else
                                    alert("Devi accedere per mettere like.")}}/>
                             }
                        </div>
                    </div>
                    
                    {/* Pulsanti modifica o elimina risposta */}
                    {(firebase.auth().currentUser != null && modifyRep !== reply.id && reply.email === firebase.auth().currentUser.email) ?
                        <div style={{ paddingBottom: '1%', width: "100%" }}>
                            <Button style={{marginRight: '1%' }} variant="info"  size= "sm"
                                onClick={() => { setModifyRep(reply.id); setModificaRep(reply.text) }}>
                                    <FontAwesomeIcon color='white' icon={faPen}/> Modifica
                            </Button>
                            <Button variant="danger"  size= "sm"
                                onClick={() => { if (window.confirm("Eliminare definitivamente la risposta?") === true) deleteReply(replies, reply.id, post.id)}}>
                                    <FontAwesomeIcon color='white' icon={faTrashAlt} />
                            </Button>
                        </div>
                    : null}
                    
            </div>
        )
    }

    const onHideModalShare = () => {
        setShowShare(false);
    }

    const renderPost = post => {
        return(
            <div className="post" >
                <div className="row input--commenti" style={{marginTop:"1%", marginInline: "5%", justifyContent: "space-between"}}>
                    <div className='row' style={{width: "30%", textAlign: "left", alignSelf: "center"}}>
                        <div style={{marginRight: "3%", alignSelf: "center" }}>
                        </div>
                    </div>
                    {/* UTENTE */}
                    <div className='row' style={{width: "40%", alignContent: "center", justifyContent:"center" ,color: "lightgreen"}}>
                        
                        <div style={{alignSelf: "center", textAlign: "center" }}>
                            <text> {post.user} </text>
                        </div>
                    </div>
                    {/* DATA */}
                    <div className='row' style={{width: "30%", alignContent: "center", justifyContent: "center", color: "rgb(216, 216, 218)"}}>
                        
                        <div style={{alignSelf: "center", textAlign: "center" }}>
                            <text >{timeSince(post.data.seconds*1000)} fa</text>
                        </div>
                    </div>
                </div>
                <hr style={{backgroundColor: "rgb(194, 194, 194)", marginInline: "4%", marginTop: "0%", height: "2px"}}/>
                <div className="commenti--contenuti" style={{display: "flex", flexWrap: "wrap"}} >
                    {modify !== post.id ? 
                        <>
                            {/* Contenuto post */}
                            <div style={{width: "90%"}}>
                                <text style={{fontSize: 18}}>
                                    {renderText(post.text)}
                                </text>
                                <br/>
                                <div className='post-gallery-div'>
                                    {post.img.length > 0  ? (
                                        post.img.map( (img, index) => {
                                            return (
                                                <div className='post-image-div' key={index}>
                                                    <img src={img.url} style={{width: "100%", borderRadius: "5%"}} onClick={() => {setCurrentImage(img); setViewerIsOpen(true)}}/>
                                                </div>)
                                            } 
                                        )
                                    )
                                        : null
                                    }
                                </div>
                                {/* MODAL IMAGE */}
                                <div className={viewerIsOpen? 'image-viewer open' : "image-viewer"}  onClick={() => setViewerIsOpen(false)} >
                                    <img src={currentImage.url} />
                                </div> 
                                <div class="post--tags">
                                    {post.tags.map( tag => " #"+tag)}
                                </div>
                            </div>
                        </> :
                        <>
                            {/* Pulsanti modifica post */}
                            <div style={{width: "90%"}}>
                                <textarea maxLength={1000} style={{fontSize: "18px"}}  value={modifica} className='input' type='text' onChange={event => setModifica(event.target.value)} />
                                <div>
                                    <Button 
                                        style={{marginLeft: "2%"}} size= "sm"  variant ="info"
                                        onClick={() => {
                                            setModify(null);
                                            firebase.firestore().collection('post').doc(post.id).update({ 
                                                text: modifica,
                                                last_modified : firebase.firestore.Timestamp.fromDate(new Date())
                                            });
                                        }}>
                                        <FontAwesomeIcon color='white' icon={faCheck} />
                                    </Button>
                                    <Button 
                                        style={{marginLeft: "2%"}}
                                        variant="danger" size= "sm"
                                        onClick={() => 
                                            setModify(null)
                                        }>
                                        <FontAwesomeIcon color='white' icon={faTimes} />
                                    </Button>
                                </div>
                            </div>
                        </>
                    }
                    {/* Likes */}
                    <div style={{width: "5%", textAlign: "center"}}>
                        {post.likes.length}<br/>
                        {firebase.auth().currentUser !== null && post.likes.length !== 0 && post.likes.includes(firebase.auth().currentUser.email)? 
                                <FontAwesomeIcon className='cursor-pointer' icon={faHeart} color="red" onClick={() => {removeLikePost(post)}}/>:
                                <FontAwesomeIcon className='cursor-pointer' icon={faHeart} color="lightgrey" onClick={ () =>{
                                    if(firebase.auth().currentUser !== null)
                                    addLikePost(post)
                                    else
                                    alert("Devi accedere per mettere like.")
                                }}/>
                             }
                    </div>
                    {/* Pulsanti modifica o elimina post */}
                    
                    {(firebase.auth().currentUser != null && modify !== post.id && post.email === firebase.auth().currentUser.email) ?
                        <div style={{ paddingBottom: '1%', width: "50%" }}>
                            <Button style={{marginRight: '1%' }} variant="info" size= "sm"
                                onClick={() => { setModify(post.id); setModifica(post.text); setModificaTags(post.tags) }}>
                                    <FontAwesomeIcon color='white' icon={faPen}/> Modifica
                            </Button>
                            <Button variant="danger"  size= "sm"
                                onClick={() => { if (window.confirm("Eliminare definitivamente il post?") === true) deletePost(post)}}>
                                    <FontAwesomeIcon color='white' icon={faTrashAlt} />
                            </Button>
                        </div> 
                    : null}
                    <div style={{width: "100%", textAlignLast: "end"}}> 
                        <FontAwesomeIcon icon={faShareAlt} size='2x'  style={{ marginLeft: "10px", cursor: "pointer", color: "lightgrey"}} onClick={() => {setUrl(window.location.href+"/"+post.id); setShowShare(true)}}/>
                   </div>
                             
                </div>
                
                {/* Accordion per risposte */}
                <Accordion style={{  borderColor: "#1c242b", borderRadius: "10px"}} >
                    <Card style={{borderColor: "#1c242b", width: "100%", borderWidth: "0px", backgroundColor: "#1c242b", borderRadius: "10px" }}>
                        <AccordionToggle  class="testo-risposte" as={Card.Header} eventKey="rosin"  style={{backgroundColor: "#1c242b", borderRadius: "0px 0px 10px 10px", marginBottom: "5px"}}>    
                            <text className='cursor-pointer' style={{fontSize: 15, color: "white"}}>Risposte ({post.replies.length})</text>
                        </AccordionToggle>
                            <AccordionCollapse eventKey="rosin" style={{backgroundColor: "rgb(194, 194, 194)", borderRadius: "0px 0px 10px 10px"}}>
                            <Card.Body style={{textAlign: "center", paddingInline: "10px", paddingBottom: "2%", paddingTop: "0px"}}>
                                {post.replies.length === 0 ?
                                    <text style={{textAlign: "center", color: "black"}}> Non ci sono risposte. </text>:
                                    post.replies.map(reply => {
                                        return renderReply(post, reply, post.replies)
                                    })
                                }
                                {firebase.auth().currentUser == null ? 
                                <div className="per--commenti">
                                    <Link to="/login" style={{color: "red", textDecoration: "underline" }}> Accedi</Link> per scrivere un post
                                </div> :
                                <div className="per-commentare row" style={{ width: "90%", marginTop: "2%", justifyContent: "center"}}>
                                    <div className='row' style={{width: "100%", justifyContent: "center"}}>
                                        <textarea maxLength={1000} style={{ paddingInline: "2%" }} value={reply} className='input input--commenti input--post' type='text' 
                                            placeholder={"Lascia una risposta..."} 
                                            onChange={event => setReply(event.target.value)} />
                                        <div style={{marginLeft: "1%", color: "rgb(194, 194, 194)"}}>
                                            {uploadingReply?
                                                <div style={{color: "#1c242b"}}>
                                                    <Spinner animation="border" role="status" />
                                                </div>
                                                :
                                                <Button 
                                                    style={{ backgroundColor: "#2c2c32", marginLeft: "2%" }} variant="secondary" 
                                                    disabled={reply === '' ? true : false} onClick={() => sendReply( post.id, post.replies)}>
                                                        <FontAwesomeIcon icon={faPaperPlane}/>
                                                </Button>
                                            }   
                                        </div>
                                            
                                    </div>
                                    {/* Input file */}
                                    <div style={{ textAlignLast: "left", color: "white"}}>
                                        <FontAwesomeIcon icon={faImages} size="lg" style= {{ verticalAlign: "bottom", paddingRight: "2%", color: "black"  }} />
                                        <input type="file" accept="image/png, image/jpeg" id="inputForm" multiple={5}
                                            style={{fontSize: 10, width: "80%", color: "black"}} 
                                            onChange={event => { setFile(event)} }
                                            />
                                    </div>
                                </div>
                                }

                                </Card.Body>
                            </AccordionCollapse>
                    </Card>
                </Accordion>
            </div>
        )  
    }

    const renderSinglePost = () => {
        ref.doc(id).onSnapshot(querySnapshot => {
            console.log(querySnapshot.data())
            setTemp(querySnapshot.data())
        });
    }

    return (
        <div>
            {temp && id ?
            <div style={{justifyContent: "center", alignContent:"center"}}>
                    <div style={{color:"lightgrey"}}>
                    <FontAwesomeIcon icon={faTimesCircle}  style={{cursor: "pointer"}} onClick={() => history.push("/community") }  /> 
                    <text style={{ marginLeft: "10px", cursor: "pointer"}} onClick={() => history.push("/community") } >
                        Torna alla Community
                    </text>  
                    </div>  
                    <div class="row" style={{justifyContent: "center", alignContent: "center"}}>
                        {renderPost(temp)}
                    </div>
            </div>
            :
            <>
            <h2 style={{color: "white"}}>Scrivi alla Community!</h2>
            {loading ? 
                <h3 style={{ color: 'white' }}>
                    <Spinner animation="grow" color="white" />
                </h3>:
                <>
                <div className='row' style={{color: "black", justifyContent: "center" }}>
                    {/*TAGS FILTRI*/}
                    <ToggleButtonGroup  
                        type="checkbox" value={selectedTags} className="tag-group" size="sm" 
                        onChange={tag => {setSelectedTags(tag); switchTagFilter(tag)}} >
                        {tagList.map( tag => {
                            return(
                            <ToggleButton id="tbg-btn-1" value={tag}  variant="secondary"
                                style={{fontSize: "13px",boxShadow: "none", borderColor: "rgb(44, 44, 50)"}} >
                                #{tag}
                            </ToggleButton>)
                        })}
                    </ToggleButtonGroup>
                </div>
                
                {firebase.auth().currentUser == null ? 
                    <div className="per--commenti">
                        <Link to="/login" style={{color: "red", textDecoration: "underline" }}> Accedi</Link> per scrivere un post
                    </div> :
                    <div className="per-commentare row" style={{ justifyContent: "center"}}>
                    {/* Input testo */} 
                    <div className="per-commentare " style={{ width: "100%", marginTop: "2%", justifyContent: "center"}}>
                        <div className='row' style={{ width: "100%", justifyContent: "center", marginLeft: 0}}>
                            <textarea style={{ paddingInline: "2%" }} value={commento} maxLength={1000} className='input input--commenti input--post' type='text'
                                    placeholder="A cosa stai pensando?"  
                                    onChange={event => setCommento(event.target.value)} />
                                <div style={{ marginLeft: "1%", color: "rgb(194, 194, 194)"}}>
                                    {uploadingPost?
                                        <Spinner animation="border" role="status" />
                                        :
                                        <Button 
                                            style={{ backgroundColor: "#2c2c32", marginLeft: "2%" }} variant="secondary" 
                                            disabled={commento.length != 0 && selectedTags.length != 0 ? false : true} onClick={() => sendPost()}>
                                                <FontAwesomeIcon icon={faPaperPlane}/>
                                        </Button>
                                    }
                            </div>
                        </div>
                            
                            {/*Input tags*/}
                            <div className='row' style={{ width: "100%", justifyContent: "center", marginLeft: 0}}>
                                <text style={{color: "white", alignSelf: "center", fontSize: "10px"}}>tags:</text>
                                <ReactTagInput 
                                    tags={selectedTags} 
                                    placeholder="Scrivi il tag e premi Invio ↵"
                                    maxTags={5}
                                    editable={true}
                                    readOnly={true}
                                    removeOnBackspace={true}
                                    onChange={(newTags) => setSelectedTags(newTags)}
                                />
                            </div>
                        </div>
                        {/* Input file */}
                        <Accordion style={{  borderColor: "#1c242b", borderRadius: "10px"}} >
                            <Card  style={{borderColor: "#1c242b", width: "100%", borderWidth: "0px", backgroundColor: "#2c2c32", borderRadius: "10px" }}>
                                <AccordionToggle  class="testo-risposte" as={Card.Header} eventKey="rosin"  style={{borderRadius: "0px 0px 10px 10px", marginBottom: "5px"}}>    
                                    <text className="inserisci-allegati cursor-pointer" style={{ color: "white"}}>Inserisci allegati</text><FontAwesomeIcon icon={faPaperclip} size='lg' style={{color: "white", paddingLeft: "2%"}} />
                                </AccordionToggle>
                                    <AccordionCollapse eventKey="rosin" style={{backgroundColor: "rgb(194, 194, 194)", borderRadius: "0px 0px 10px 10px"}}>
                                    <Card.Body style={{textAlign: "center", paddingInline: "10px", paddingBottom: "2%", paddingTop: "0px"}}>
                                        {/* Input file */}
                                        <div style={{ textAlignLast: "left"}}>
                                            <FontAwesomeIcon icon={faImages} size="lg" style= {{ verticalAlign: "bottom", paddingRight: "2%"  }} />
                                            <input type="file" accept="image/*" id="inputForm" multiple={10}
                                                style={{fontSize: 10, width: "80%", color: "red"}} 
                                                onChange={event => { setFile(event)} }
                                                />
                                        </div>
                                    </Card.Body>
                                </AccordionCollapse>
                            </Card>
                        </Accordion>
                       
                    </div>
                }
                {/* Posts */}
                {filteredPosts.length === 0 ?
                    <>
                        <br/>
                        <h3 style={{color: "white"}}>Nessun contenuto.</h3>
                    </>
                :
                    <div className="conteinerRecensioni">
                        {filteredPosts.map(post => {
                            return renderPost(post)
                        }
                        )}
                    </div>
                }
                </>
            }
            </>
            }
            <Modal size="md" show={showShare} centered onHide={() => onHideModalShare()} >
            <ModalBody>
                <div className="row" style={{justifyContent: "space-evenly"}}>
                    <div style={{color: 'white', alignSelf: "center", cursor: "pointer"}} onClick={() => {navigator.clipboard.writeText(url); onHideModalShare()}}>
                        <FontAwesomeIcon icon={faLink} size="2x" />
                        <text style={{verticalAlign: "super", marginLeft: "2px"}}>Link</text>
                    </div>
                    <div style={{color: 'white'}}>
                        <EmailShareButton url= {url}>
                            <EmailIcon round={true} size={40} />
                            Email
                        </EmailShareButton>
                    </div>
                    <div style={{color: 'white'}}>
                        <WhatsappShareButton url= {url} >
                            <WhatsappIcon round={true} size={40} />
                            Whatsapp
                        </WhatsappShareButton>
                    </div>
                    <div style={{color: 'white'}}>
                        <TelegramShareButton url= {url} >
                            <TelegramIcon round={true} size={40} />
                            Telegram
                        </TelegramShareButton>
                    </div>
                    <div style={{color: 'white'}}>
                        <FacebookShareButton url= {url}>
                            <FacebookIcon round={true} size={40}/>
                            Facebook
                        </FacebookShareButton>
                    </div>
                    <div style={{color: 'white'}}>
                        <TwitterShareButton url= {url} >
                            <TwitterIcon round={true} size={40}/>
                            Twitter
                        </TwitterShareButton>
                    </div>
                    <div style={{color: 'white'}}>
                        <FacebookMessengerShareButton url= {url} >
                            <FacebookMessengerIcon round={true} size={40}/>
                            Messenger
                        </FacebookMessengerShareButton>
                    </div>
                </div>
            </ModalBody>
        </Modal>
        </div>
        );
}